import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { useLazyGetLegalNoticeQuery } from "../app/api/public/legals";
import { router } from "../app/services/router";
import { Dialog } from "../features/shared/Dialog";
import { Loader } from "../features/shared/Loader";
import { Markdown } from "../features/shared/Markdown";

import { ReactComponent as Icon } from "./LegalNoticePageIcon.svg";

export const LegalNoticePage = () => {
  const hash = router.getTo("legalNotice");
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={hash === location.hash}
      onOpenChange={(open) => {
        if (!open) {
          navigate({ ...location, hash: "" });
        }
      }}
    >
      <LegalNoticePageContent
        trigger={document.querySelector(`[href*="${hash}"]`)}
      />
    </Dialog>
  );
};

type LegalNoticePageContentProps = { trigger: HTMLElement | null };

const LegalNoticePageContent = (props: LegalNoticePageContentProps) => {
  const { trigger } = props;

  const [getLegalNotice, { currentData: text, error, isFetching }] =
    useLazyGetLegalNoticeQuery();

  const { t } = useTranslation();
  const { meta, title } = t("pages.LegalNoticePage") as unknown as {
    meta: { title: string };
    title: string;
  };

  return (
    <Dialog.Content
      dataLayer={{
        categorie_page: "mentions_legales",
        nom_page: "mentions_legales",
        virtualpagetitle: "Mentions légales",
      }}
      icon={<Icon />}
      meta={meta}
      title={title}
      onCloseAutoFocus={() => trigger?.focus()}
      onOpenAutoFocus={() => getLegalNotice(undefined, true)}
    >
      {text ? (
        <Markdown>{text}</Markdown>
      ) : (
        <Loader error={error} isFetching={isFetching} />
      )}
    </Dialog.Content>
  );
};
